var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},_vm._l((_vm.total),function(bar,idx){return _c('div',{key:idx,staticClass:"bar",class:`idx-${idx + 1}`,style:({'width': _vm.widthMiniBar })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }